import { useBatchedSimpleWorkArea } from "@/-dataloaders/simple-work-areas"

export function WorkAreaName({ workAreaId }: { workAreaId: number }) {
  const { data: workArea } = useBatchedSimpleWorkArea(workAreaId)
  return `${workArea?.department?.name} / ${workArea?.name}`
}
